<template>
  <header class="container-wide">
    <div class="logo">
      <router-link to="/spartan">
        <img src="../assets/spartan-logo-web_1.svg" alt="spartan builders" />
      </router-link>
      <router-view />
    </div>
    <div class="container-inner">
      <nav class="spartan-top-header">
        <ul class="spartan-qualities">
          <li>integrity</li>
          <li>quality</li>
          <li>experience</li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: "SpartanHeader"
};
</script>

<style lang="scss" scoped>
@import "./src/stylesheets/base/_variables.scss";


.spartan-home {
  .logo {
    @media screen and (max-width: $medium-bp) {
      width: 70%;
      margin: auto;
    }

    @media screen and (min-width: $medium-bp+0.1) {
      width: 25%;
      margin-top: 1em;
      margin-left: 5%;
    }
  }

  .spartan-top-header {
    // border: 1px solid red;

    @media screen and (min-width: $medium-bp+0.1) {
      width: 24%;
    }
  }

  .spartan-qualities {
    list-style: none;
    @media screen and (max-width: $medium-bp) {
      display: flex;
      justify-content: center;
      font-size: 0.8em;
    }

    @media screen and (min-width: $medium-bp+0.1) {
      text-align: right;
      display: flex;
      flex-direction: column;
      justify-content: center;
      border-right: 1px solid #000;
    }
  }
}

.spartan-qualities > li {
  @media screen and (max-width: $medium-bp) {
    margin-left: 1em;
    margin-right: 1em;
  }

  @media screen and (min-width: $medium-bp+0.1) {
    margin-right: 1em;
  }
}
</style>
